import { useState } from 'react';
import { useQuickQuoteContext } from 'contexts/QuickQuoteContext';
import { getFullUrl } from '../utils/utils';

export const useAutoCompleteApi = () => {
  const [loading, setLoading] = useState(false);
  const { partnerId } = useQuickQuoteContext();

  const getAutoComplete = async (term) => {
    setLoading(true);

    const sessionToken = Math.random().toString(36).substring(2) +
        (new Date()).getTime().toString(36);

    const params = new URLSearchParams({
        sessiontoken: sessionToken,
        term: term,
        brand: window.gon.current_brand
    });
    
    // Conditionally add `partner_id` and `partner_autocomplete_results`
    if (partnerId) {
        params.append('partner_id', partnerId);
        params.append('partner_autocomplete_results', 'true');
    }
    
    if (window.user_ident) {
        params.append('user_id', window.user_ident)
    }
    
    const url = `${window.gon.autocomplete_all_endpoint}?${params.toString()}`;
    const apiEndpoint = getFullUrl(url);

    try {
      const response = await fetch(apiEndpoint, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `Error: ${response.status}`);
      }

      return {
        success: true,
        message: '',
        data: data
      };
    } catch (error) {
      const errorMessage = error.message === 'email is already used'
        ? error.message
        : 'Something went wrong. Please try again.';

      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return { getAutoComplete, loading };
};
